import { PayoutFormContext } from 'modules/host-payout-methods/context/PayoutFormContext';
import { useContext, useEffect } from 'react';
import { useAccount } from '~/authentication/store';

const usePayoutAccounts = () => {
  const { actions, payoutAccounts } = useContext(PayoutFormContext);
  const { account, loading } = useAccount();
  const accountId = account?.id;

  useEffect(() => {
    if (!loading && !!accountId) {
      actions.fetchPayoutAccounts({ accountId });
    }
  }, [actions, accountId, loading]);

  return payoutAccounts;
};

export default usePayoutAccounts;
